import { connect } from 'react-redux';
import { IApplicationState } from '../../../../../../../../types/types';
import { GanttSection } from '../../components/GanttSection/GanttSection';
import { IGanttSectionFields } from '../../components/GanttSection/types';
import { getIsUserEssentialPlanOnly } from '../../../../../../../../store/model/authUser/selectors/getIsUserEssentialPlanOnly';

const mapStateToProps = (
    state: IApplicationState,
): IGanttSectionFields => {
    return {
        isEssentialFeature: getIsUserEssentialPlanOnly(state)
    }
};

export const GanttSectionHOC = connect(
    mapStateToProps,
    null
)(GanttSection);

GanttSectionHOC.displayName = 'GanttSectionHOC';
